<template>
  <div v-if="show"
       class="toast-loading">
    <div class="toast-loading-shack"></div>
    <div class="toast-loading-box">
      <i class="icon-toast"
         :class="[`${loadingType ? 'loading' : 'success'}`]"></i>
      <p v-if="bodyContent"
         class="content">{{bodyContent}}</p>
      <slot></slot>
    </div>
  </div>
</template>

<style lang="less" rel="stylesheet/less">
.toast-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.toast-loading-shack {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.toast-loading-box {
  height: 1.4rem;
  // width: 1.4rem;
  border-radius: 0.1rem;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 50%;
  // left: 50%;
  // margin: -0.7rem 0 0 -0.7rem;
  margin: -2rem 0 0 0;
  color: #fff;
  font-size: 0.28rem;
  z-index: 2000;
  text-align: center;
  padding: 0rem 0.6rem;
  .icon-toast {
    display: block;
    height: 0.6rem;
    width: 0.6rem;
    margin: 0 auto;
    margin-top: 0.18rem;
    margin-bottom: 0.08rem;
  }
  .loading {
    background: url("../assets/images/loading.png");
    background-size: 100% 100%;
    animation: weuiLoading 1s steps(12, end) infinite;
  }
  .success {
    background: url("../assets/images/success.png");
    background-size: 100% 100%;
  }
  @-webkit-keyframes weuiLoading {
    0% {
      transform: rotate3d(0, 0, 1, 0deg);
    }

    100% {
      transform: rotate3d(0, 0, 1, 360deg);
    }
  }

  @keyframes weuiLoading {
    0% {
      transform: rotate3d(0, 0, 1, 0deg);
    }

    100% {
      transform: rotate3d(0, 0, 1, 360deg);
    }
  }
}
</style>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    bodyContent: {
      type: String,
    },
    loadingType: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
